import { render } from "./AppTag.vue?vue&type=template&id=3d61207b&scoped=true&ts=true"
import script from "./AppTag.vue?vue&type=script&lang=ts"
export * from "./AppTag.vue?vue&type=script&lang=ts"

import "./AppTag.vue?vue&type=style&index=0&id=3d61207b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d61207b"]])

export default __exports__